import React, {Component} from 'react';
import { Formik, Form, Field } from 'formik';
import _ from 'underscore';
import {
    Grid,
    Button,
    Message
} from 'semantic-ui-react';

import FormsInputsDropdown from '../../inputs/dropdownbank/index';
import FormsInputsText from '../../inputs/text/forms_inputs_text';
import BankUtility from '../../../../utils/bankUtility/BankUtility';
const FLAG_BRANCH_NOT_SELECTED = "BRANCH_NOT_SELECTED";
//import UpdateBankSchema from './validation';

// const prepareBankOrBranchListOptions = (list) => {
//     return _.map(list, (item, index) => {
//         return { text: item.n, value: item.c, key: index};
//     });
// }

const prepareBankListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.n, key: index};
    });
}

const prepareBranchListOptions = (list, bankName) => {
    for (var i=0; i< list.length; i++) {
        if(list[i].n.toLowerCase() === bankName.toLowerCase()){
          let branchList = _.map(list[i].branches, (item, index) => {
              return { text: item.n, value: item.c, key: index};
          });
          branchList.unshift({ text: "-- Please Select Branch --", value: FLAG_BRANCH_NOT_SELECTED})
          return branchList;
        }
    }
}

const getBankName = (list, bankNo, accountNo) => {
    //alert(number, list);
    for(var i=0; i<list.length; i++){
        if(list[i].c === bankNo){
          if (accountNo.length === 9){
              return 'POSBank'
          }
          return list[i].n;
        }
    }
}

const getBankNo = (list, bankName) => {
    //alert(number, list);
    for(var i=0; i<list.length; i++){
        if(list[i].n.toLowerCase() === bankName.toLowerCase()){
          return list[i].c;
        }
    }
}

class FormsRegisterBankAccount extends Component {

    bankUtility = new BankUtility();
    state = {
        error: false,
        errorMessage: null,
        success: false,
        skipped: false
    }
    constructor(props) {
        super(props);
        this.skipBank = this.skipBank.bind(this);
    }
    renderFormSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Grid.Column width={16}>
                    <Message positive>
                        <Message.Header>Bank Account Changed Successfully!</Message.Header>
                    </Message>
                </Grid.Column>
            );
        }
        if (this.state.error === true) {
            return (
                <Grid.Column width={16}>
                    <Message negative>
                        <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                        <p>
                            { this.state.errorMessage }
                        </p>
                    </Message>
                </Grid.Column>
            );
        }
    }
    skipBank(){

        this.state.skipped=true;
    }

    onBankNameChange(evt, formikData){
        let bankName = formikData.field.value;
        let accountNo = formikData.values.accountNo;
        let accountNoConfirm = formikData.values.accountNoConfirm;
        formikData.setFieldValue("bankName", bankName);

        // auto select branch
        this.selectBranch(bankName, accountNo, accountNoConfirm, formikData);
    }

    onBankAccountChange(evt, formikData){
        try{
            let bankName = formikData.values.bankName;
            let accountNo = evt.target.name === "accountNo" ? evt.target.value : formikData.values.accountNo;
            let accountNoConfirm = evt.target.name === "accountNoConfirm" ? evt.target.value : formikData.values.accountNoConfirm;
    
            // validate number
            accountNo = accountNo.replace(/\D+/g, '');
            accountNoConfirm = accountNoConfirm.replace(/\D+/g, '');
    
            // set the filtered value to responsible variable
            if(evt.target.name === "accountNo"){
                formikData.setFieldValue("accountNo", accountNo);
            }else if(evt.target.name === "accountNoConfirm"){
                formikData.setFieldValue("accountNoConfirm", accountNoConfirm);
            }

            // auto select branch
            this.selectBranch(bankName, accountNo, accountNoConfirm, formikData);
            
        }catch(err){
            console.error(err);
        }
    }

    selectBranch(bankName, accountNo, accountNoConfirm, formikData){
        try{
            const bankNo = getBankNo(formikData.bankList, bankName);
            const branchCode = this.bankUtility.getBranchCode(bankNo, accountNo);
            const bankInUI = formikData.bankList.find( bank => bank.c === bankNo );
            const branchInUI = bankInUI.branches.find( branch => branch.c === branchCode );

            // General validation for account no digit
            this.bankUtility.isValidAccountNoDigit(bankNo, accountNo);
            
            // Populate UI
            // Handle Bank of China
            if( bankNo === "7083" && accountNo === accountNoConfirm ){
                formikData.setFieldValue("branchNo", "011");
                formikData.setFieldValue("accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
                formikData.setFieldValue("accountNoConfirm", this.bankUtility.getAccountNo(bankNo, accountNoConfirm) || accountNoConfirm);
            }
            else if( branchCode && branchInUI && (accountNo === accountNoConfirm)){

                if( ["7339", "7232", "9548", "7991"].includes(bankNo) ){
                    window.alert("Please note that the first 3 digits of the Account No is dropped and used as the Branch Code");
                }

                formikData.setFieldValue("branchNo", branchCode);
                formikData.setFieldValue("accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
                formikData.setFieldValue("accountNoConfirm", this.bankUtility.getAccountNo(bankNo, accountNoConfirm) || accountNoConfirm);
            }else{
                throw new Error("Branch not found");
            }
        }catch(err){
            formikData.setFieldValue("branchNo", FLAG_BRANCH_NOT_SELECTED);
        }
    }

    render() {
        // console.log(this.props.bankList);
        const { bbl, bl, blV2 } = this.props.bankList;
        const {updateStepIndex} = this.props;

        return (
            <Formik
                initialValues={{
                    bankName: "",
                    bankNo: "",
                    accountNo: "",
                    accountNoConfirm: "",
                    branchNo: ""
                }}
                validateOnChange={false}
                validateOnBlur={false}
                //validationSchema={UpdateBankSchema}
                validate={(values) => {
                    // Additional Validation (if any)
                    let error = {};
                    if (values.accountNo !== values.accountNoConfirm) {
                        error.accountNoConfirm = 'Account Numbers do not match.'
                    }
                    return error;
                }}
                onSubmit={(values, actions) => {
                    // console.log(values, actions);

                    var _bankNo = getBankNo(blV2, values.bankName)

                    if(!this.state.skipped){
                        this.setState({error: false, errorMessage: null});
                        this.props.registerActivateAccount({
                            nric: this.props.identifier,
                            password: this.props.password,
                            email: this.props.email,
                            contactNo: this.props.contactNo,
                            contactNoCountryCode: this.props.contactNoCountryCode,
                            bankDetails:{bankName:values.bankName, bankNo:_bankNo, branchNo:values.branchNo, accountNo:values.accountNo}
                        }, (result, error) => {
                            if (error) {
                                this.setState({error: true, errorMessage: error.errorMessage});
                                actions.setSubmitting(false);
                            }
                            if (result) {
                                updateStepIndex(7, {});
                            }
                        });
                    } else {
                        this.setState({error: false, errorMessage: null});
                        this.props.registerActivateAccount({
                            nric: this.props.identifier,
                            password: this.props.password,
                            email: this.props.email,
                            contactNo: this.props.contactNo,
                            contactNoCountryCode: this.props.contactNoCountryCode,
                            bankDetails:{bankName:"", bankNo:"", branchNo:"", accountNo:""}
                        }, (result, error) => {
                            if (error) {
                                this.setState({error: true, errorMessage: error.errorMessage});
                                actions.setSubmitting(false);
                            }
                            if (result) {
                                updateStepIndex(7, {});
                            }
                        });

                    }
                }}

                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                }) => (
                    <Form style={{paddingBottom: 20, paddingTop: 20}}>
                        <Grid columns={2}>
                            <Grid.Column width={16}>
                                <Field
                                    name="bankName"
                                    label="Bank"
                                    component={FormsInputsDropdown}
                                    secondaryLabel="Choose Your Bank"
                                    options={prepareBankListOptions(blV2)}
                                    onChange={(e, formikField)=>{ this.onBankNameChange(e, {values, setFieldValue, bankList : blV2, field:formikField}) }}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field
                                    name="accountNo"
                                    label="Account Number"
                                    component={FormsInputsText}
                                    secondaryLabel="State your Account Number"
                                    onChange={(e, formikField)=>{ this.onBankAccountChange(e, {values, setFieldValue, bankList : blV2, field:formikField}) }}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field
                                    name="accountNoConfirm"
                                    label="Confirm Account Number"
                                    component={FormsInputsText}
                                    secondaryLabel="Confirm Your Account Number"
                                    onChange={(e, formikField)=>{ this.onBankAccountChange(e, {values, setFieldValue, bankList : blV2, field:formikField}) }}
                                />
                            </Grid.Column>

                            <Grid.Column width={16}>
                                    <Field
                                        name="branchNo"
                                        label="Branch Number"
                                        component={FormsInputsDropdown}
                                        secondaryLabel="Choose Your Branch"
                                        options={(values.bankName) ? prepareBranchListOptions(blV2, values.bankName) : []}
                                    />
                            </Grid.Column>

                            {/* Display error or sucess info */}
                            {this.renderFormSubmissionResult()}

                            <Grid.Column width={8}>
                                <Button
                                    loading={isSubmitting}
                                    type="submit"
                                    primary
                                    disabled={isSubmitting}
                                    fluid
                                    size="medium"
                                >
                                    Add my Bank Details
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Button
                                    loading={isSubmitting}
                                    onClick={this.skipBank}
                                    primary
                                    disabled={isSubmitting}
                                    fluid
                                    size="medium">
                                    Skip
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default FormsRegisterBankAccount;
